import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  reconciliationService,
  type MergeBody,
  type SuggestArgs,
} from '../services/reconciliation.service';

export function useMergeTransactions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: MergeBody) => reconciliationService.merge(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['financial-ops', 'transactions'] });
      qc.invalidateQueries({ queryKey: ['bank-imports'] });
    },
  });
}

export function useUnmergeTransactions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { survivorId: string; transactionIds?: string[] }) =>
      reconciliationService.unmerge(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['financial-ops', 'transactions'] });
    },
  });
}

export function useReconciliationSuggestions(args: SuggestArgs | null) {
  return useQuery({
    queryKey: ['reconciliation', 'suggestions', args],
    queryFn: () => reconciliationService.suggestions(args!),
    enabled: !!args,
  });
}
